import React from 'react'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import { dialogTypes } from '@/dialogs'

const ResetPasswordButton = (props) => {
  const { user, openDialog } = props
  const showError = () => {
    openDialog({
      dialogType: dialogTypes.alert,
      title: 'UsersManagement.ResetPassword',
      content: 'UsersManagement.ResetPasswordInActiveUserError'
    })
  }
  if (user.isActive) {
    return (
      <Button
        key='resetPasswordButton'
        color='primary'
        className='btn btn-sm'
        onClick={props.onClick}
        confirmTitle='UsersManagement.ResetPasswordConfirmTitle'
        confirmText='UsersManagement.ResetPasswordConfirmText'
        icon='key'>
        <Resx name='UsersManagement.ResetPassword' />
      </Button>
    )
  } else {
    return (
      <Button
        key='resetPasswordButton'
        color='primary'
        className='btn btn-sm'
        onClick={showError}
        icon='key'>
        <Resx name='UsersManagement.ResetPassword' />
      </Button>
    )
  }
}

export { ResetPasswordButton }



// WEBPACK FOOTER //
// ./src/components/usersManagement/resetPasswordButton.js